module.exports = __webpack_public_path__ + "static/media/logo.a9cf3e7f.svg";